var map = {
	"./arrow_right.svg": 1087,
	"./bag.svg": 1089,
	"./caret_down.svg": 1090,
	"./chevron_down.svg": 1091,
	"./chevron_down_small.svg": 1092,
	"./chevron_left.svg": 1093,
	"./chevron_right.svg": 1094,
	"./chevron_up.svg": 1095,
	"./chevron_up_small.svg": 1096,
	"./close.svg": 1097,
	"./heart.svg": 1098,
	"./info-filled.svg": 1099,
	"./search-no-results.svg": 1100,
	"./search.svg": 1101,
	"./social-logo/apple.svg": 1102,
	"./social-logo/facebook.svg": 1103,
	"./social-logo/google.svg": 1104,
	"./stone-shape/asscher.svg": 1105,
	"./stone-shape/baguette.svg": 1106,
	"./stone-shape/cushion.svg": 1107,
	"./stone-shape/emerald.svg": 1108,
	"./stone-shape/heart.svg": 1109,
	"./stone-shape/marquise.svg": 1110,
	"./stone-shape/oval.svg": 1111,
	"./stone-shape/pear.svg": 1112,
	"./stone-shape/princess.svg": 1113,
	"./stone-shape/radiant.svg": 1114,
	"./stone-shape/round.svg": 1115,
	"./stone-shape/tapered-baguette.svg": 1116,
	"./stone-shape/triangle.svg": 1117,
	"./stone-shape/trillion.svg": 1118,
	"./tag.svg": 1119,
	"./truck.svg": 1120,
	"./user.svg": 1121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1086;